module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Like-bab85a06b7e215b2ca6448cb9a8dd1c4.svg";